import React, {Component} from 'react'
import {Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

export default class UserRoleRateInput extends Component {

    state = {
        mon: '',
        tue: '',
        wed: '',
        thu: '',
        fri: '',
        sat: '',
        sun: '',
        active_from: ''
    }

    render() {

        const {user_role_name, loading, isOpen, toggle, onSave} = this.props
        const {
            mon,
            tue,
            wed,
            thu,
            fri,
            sat,
            sun,
            active_from
        } = this.state

        return (

            <Modal isOpen={isOpen} toggle={toggle}>
                <AvForm
                    onValidSubmit={() => {
                        if (onSave) onSave(this.state)
                    }}
                >
                    <ModalHeader>Create Hourly Rates for {user_role_name}</ModalHeader>
                    <ModalBody>


                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="number"
                                    name="monday"
                                    bsSize="sm"
                                    label="Monday*"
                                    errorMessage="Required"
                                    placeholder="Hourly Rate"
                                    value={mon}
                                    onChange={(evt) => this.setState({mon: evt.target.value})}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="number"
                                    name="tuesday"
                                    bsSize="sm"
                                    label="Tuesday*"
                                    errorMessage="Required"
                                    placeholder="Hourly Rate"
                                    value={tue}
                                    onChange={(evt) => this.setState({tue: evt.target.value})}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="number"
                                    name="wednesday"
                                    bsSize="sm"
                                    label="Wednesday*"
                                    errorMessage="Required"
                                    placeholder="Hourly Rate"
                                    value={wed}
                                    onChange={(evt) => this.setState({wed: evt.target.value})}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="number"
                                    name="thursday"
                                    bsSize="sm"
                                    label="Thursday*"
                                    errorMessage="Required"
                                    placeholder="Hourly Rate"
                                    value={thu}
                                    onChange={(evt) => this.setState({thu: evt.target.value})}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="number"
                                    name="friday"
                                    bsSize="sm"
                                    label="Friday*"
                                    errorMessage="Required"
                                    placeholder="Hourly Rate"
                                    value={fri}
                                    onChange={(evt) => this.setState({fri: evt.target.value})}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="number"
                                    name="saturday"
                                    bsSize="sm"
                                    label="Saturday*"
                                    errorMessage="Required"
                                    placeholder="Hourly Rate"
                                    value={sat}
                                    onChange={(evt) => this.setState({sat: evt.target.value})}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="number"
                                    name="sunday"
                                    bsSize="sm"
                                    label="Sunday*"
                                    errorMessage="Required"
                                    placeholder="Hourly Rate"
                                    value={sun}
                                    onChange={(evt) => this.setState({sun: evt.target.value})}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <AvField
                                    required
                                    type="date"
                                    bsSize="sm"
                                    name="active_from"
                                    label="Active From Date*"
                                    errorMessage="Required"
                                    value={active_from}
                                    onChange={(evt) => this.setState({active_from: evt.target.value})}
                                />
                            </Col>
                        </Row>


                    </ModalBody>
                    <ModalFooter>
                        <Button
                            size="sm"
                            color="secondary"
                            onClick={toggle}
                        >
                            <FontAwesomeIcon
                                color="#fff"
                                icon="times"
                            />{' '}
                            Cancel
                        </Button>
                        <Button
                            size="sm"
                            color="success"
                            type="submit"
                            disabled={loading}
                        >
                            <FontAwesomeIcon
                                color="#fff"
                                icon="save"
                                spin={loading}
                            />{' '}
                            {(loading) ? 'Saving...' : "Save Hourly Rates"}
                        </Button>
                    </ModalFooter>
                </AvForm>
            </Modal>

        )
    }

}

UserRoleRateInput.propTypes = {
    user_role_name: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    onSave: PropTypes.func
}